import { render, staticRenderFns } from "./CompanyName.vue?vue&type=template&id=1878902a&scoped=true&"
import script from "./CompanyName.vue?vue&type=script&lang=ts&"
export * from "./CompanyName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1878902a",
  null
  
)

export default component.exports